const _V_LOADING = 'v-lazy-loading';
const _V_LOADED = 'v-lazy-loaded';
const _V_ERROR = 'v-lazy-error';

export default {
  _V_LOADING,
  _V_LOADED,
  _V_ERROR,
};
